/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Purpose,
    PurposeFromJSON,
    PurposeFromJSONTyped,
    PurposeToJSON,
} from './Purpose';

/**
 * 配信目的カテゴリー
 * @export
 * @interface PurposeCategory
 */
export interface PurposeCategory {
    /**
     * 配信目的カテゴリ名
     * @type {string}
     * @memberof PurposeCategory
     */
    categoryName: string;
    /**
     * 
     * @type {Array<Purpose>}
     * @memberof PurposeCategory
     */
    purposeList: Array<Purpose>;
}

export function PurposeCategoryFromJSON(json: any): PurposeCategory {
    return PurposeCategoryFromJSONTyped(json, false);
}

export function PurposeCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PurposeCategory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'categoryName': json['category_name'],
        'purposeList': ((json['purpose_list'] as Array<any>).map(PurposeFromJSON)),
    };
}

export function PurposeCategoryToJSON(value?: PurposeCategory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'category_name': value.categoryName,
        'purpose_list': ((value.purposeList as Array<any>).map(PurposeToJSON)),
    };
}

